module.exports = __webpack_public_path__ + "static/media/did-you-know-fire.583b51fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/did-you-know-fire.jpg
// module id = 1034
// module chunks = 0